// El botón sol/luna, portado de PILOT (componentes/BotonTema.jsx): fija el tema
// claro u oscuro y lo recuerda en localStorage (main.tsx lo aplica antes del
// primer render). La luna invita al modo oscuro cuando estás en claro, y el sol
// al revés — el icono muestra A DÓNDE vas, no dónde estás.
// Sin elección guardada, el tema sigue al sistema: los data-theme del CSS ya
// contemplan los tres estados.
import { useState } from "react";

export const TEMA_KEY = "kex_tema";

function oscuroActivo(): boolean {
  const t = document.documentElement.getAttribute("data-theme");
  if (t) return t === "dark";
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export default function BotonTema() {
  const [oscuro, setOscuro] = useState(oscuroActivo);

  function cambiar() {
    const nuevo = oscuro ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", nuevo);
    try {
      localStorage.setItem(TEMA_KEY, nuevo);
    } catch {
      // modo privado o almacenamiento bloqueado: el tema aplica igual en esta
      // sesión, solo no se recuerda para la próxima
    }
    setOscuro(!oscuro);
  }

  return (
    <button
      type="button"
      className="btn-tema"
      onClick={cambiar}
      aria-label={oscuro ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      title={oscuro ? "Modo claro" : "Modo oscuro"}
    >
      {oscuro ? (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4.4" />
          <path d="M12 2v2.4M12 19.6V22M2 12h2.4M19.6 12H22M4.9 4.9l1.7 1.7M17.4 17.4l1.7 1.7M4.9 19.1l1.7-1.7M17.4 6.6l1.7-1.7" />
        </svg>
      ) : (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z" />
        </svg>
      )}
    </button>
  );
}
